import { RefObject, useEffect, useState } from 'react'

interface UseIsVisibleProps {
  containerRef?: RefObject<HTMLElement>
  options?: IntersectionObserverInit
  shouldToggleVisibility?: boolean
}

export const useIsVisible = ({
  containerRef,
  options,
  shouldToggleVisibility = false,
}: UseIsVisibleProps) => {
  const [isVisible, setIsVisible] = useState(false)

  const handleToggleIsVisible = (isIntersecting: boolean) => {
    if (shouldToggleVisibility || !isVisible) {
      setIsVisible(isIntersecting)
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => handleToggleIsVisible(entry.isIntersecting),
      options,
    )
    if (containerRef?.current) observer.observe(containerRef.current)

    return () => {
      observer.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef])

  return isVisible
}
